import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { useSEO } from '../hooks/useSEO';
export function APropos() {
  useSEO('À Propos - ARWM | Excellence Gastronomique Marrakech', "Découvrez l'Association des Restaurateurs de la Wilaya de Marrakech, nos valeurs, nos missions et notre engagement pour la gastronomie marocaine.");
  const values = ["L'éthique", "L'ouverture", "Le pouvoir d'agir", 'La libre expression', 'La participation sociale', "L'anticipation"];
  const missions = ["Promouvoir l'excellence gastronomique à Marrakech", 'Défendre les intérêts des restaurateurs auprès des autorités', 'Faciliter les échanges entre professionnels du secteur', 'Organiser des événements de promotion de la gastronomie marocaine', 'Accompagner les nouveaux restaurateurs dans leurs démarches', 'Développer le tourisme gastronomique dans la région', 'Assurer une veille réglementaire et informer les adhérents', 'Favoriser la formation continue des professionnels', 'Représenter le secteur dans les instances décisionnelles'];
  const team = [{
    name: 'Imane Rmili',
    role: 'Présidente'
  }, {
    name: 'Hamza Hadni',
    role: 'Membre du Bureau'
  }, {
    name: 'Hassan Oudghiri',
    role: 'Membre du Bureau'
  }, {
    name: 'Erwann Lance',
    role: 'Membre du Bureau'
  }, {
    name: 'Nourredine Naciri',
    role: 'Membre du Bureau'
  }, {
    name: 'Mehdi Amrani',
    role: 'Secrétaire'
  }, {
    name: 'Mohamed El Karninghi',
    role: 'Trésorier'
  }, {
    name: 'Marouane El Ouarzazi',
    role: 'Membre du Bureau'
  }, {
    name: 'Oussama Laftimi',
    role: 'Membre du Bureau'
  }, {
    name: 'Soulaiman Jiddi',
    role: 'Membre du Bureau'
  }];
  return <div className="w-full" data-id="element-120">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-light-gray" data-id="element-121">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-122">
          <h1 className="font-cormorant text-7xl font-bold text-arwm-maroon mb-6" data-id="element-123">
            Excellence Culinaire
          </h1>
          <p className="font-josefin text-xl text-arwm-dark-text max-w-3xl mx-auto" data-id="element-124">
            L'Association des Restaurateurs de la Wilaya de Marrakech
          </p>
        </div>
      </section>

      {/* Marrakech Destination */}
      <section className="py-20 px-4 bg-white" data-id="element-125">
        <div className="max-w-[1280px] mx-auto" data-id="element-126">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-127">
            Notre Destination
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-8 text-center" data-id="element-128">
            Marrakech, Destination Gastronomique
          </h2>
          <div className="font-josefin text-lg text-arwm-dark-text leading-relaxed space-y-6 max-w-4xl mx-auto" data-id="element-129">
            <p data-id="element-130">
              Marrakech s'affirme comme une destination gastronomique
              incontournable, où se mêlent traditions culinaires ancestrales et
              créativité contemporaine. Notre association rassemble les
              meilleurs établissements de la ville ocre, unis par une passion
              commune pour l'excellence.
            </p>
            <p data-id="element-131">
              À travers nos actions, nous œuvrons pour valoriser le patrimoine
              gastronomique marocain tout en encourageant l'innovation et le
              professionnalisme dans le secteur de la restauration.
            </p>
          </div>
        </div>
      </section>

      {/* Mot de la Présidente */}
      <section className="py-20 px-4 bg-arwm-maroon" data-id="element-132">
        <div className="max-w-[1280px] mx-auto" data-id="element-133">
          <div className="max-w-4xl mx-auto text-center" data-id="element-134">
            <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-cream mb-4" data-id="element-135">
              Message
            </p>
            <h2 className="font-cormorant text-5xl font-bold text-white mb-12" data-id="element-136">
              Mot de la Présidente
            </h2>
            <blockquote className="font-josefin text-2xl text-arwm-cream italic leading-relaxed mb-8" data-id="element-137">
              "Notre mission est de faire rayonner la gastronomie marocaine à
              travers le monde, tout en préservant l'authenticité et la qualité
              qui font la renommée de Marrakech. Ensemble, nous construisons
              l'avenir de notre secteur."
            </blockquote>
            <p className="font-josefin text-arwm-cream text-lg" data-id="element-138">
              <strong data-id="element-139">Imane Rmili</strong>
              <br data-id="element-140" />
              Présidente de l'ARWM
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-141">
        <div className="max-w-[1280px] mx-auto" data-id="element-142">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-143">
            Nos Principes
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-144">
            Nos Valeurs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-145">
            {values.map((value, index) => <Card key={index} data-id="element-146">
                <CardContent className="py-12 text-center" data-id="element-147">
                  <h3 className="font-cormorant text-3xl font-bold text-arwm-maroon" data-id="element-148">
                    {value}
                  </h3>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Missions */}
      <section className="py-20 px-4 bg-white" data-id="element-149">
        <div className="max-w-[1280px] mx-auto" data-id="element-150">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-151">
            Notre Engagement
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-152">
            Nos Missions
          </h2>
          <div className="max-w-4xl mx-auto space-y-6" data-id="element-153">
            {missions.map((mission, index) => <div key={index} className="flex items-start space-x-4" data-id="element-154">
                <div className="flex-shrink-0 w-8 h-8 bg-arwm-maroon text-arwm-cream flex items-center justify-center font-josefin font-bold" data-id="element-155">
                  {index + 1}
                </div>
                <p className="font-josefin text-lg text-arwm-dark-text pt-1" data-id="element-156">
                  {mission}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-157">
        <div className="max-w-[1280px] mx-auto" data-id="element-158">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-159">
            Notre Équipe
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-160">
            Notre Bureau
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-161">
            {team.map((member, index) => <Card key={index} data-id="element-162">
                <CardContent className="py-8 text-center" data-id="element-163">
                  <div className="w-24 h-24 bg-arwm-maroon mx-auto mb-4 flex items-center justify-center" data-id="element-164">
                    <span className="font-cormorant text-3xl font-bold text-white" data-id="element-165">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <h3 className="font-cormorant text-xl font-bold text-arwm-dark-text mb-2" data-id="element-166">
                    {member.name}
                  </h3>
                  <p className="font-josefin text-sm text-arwm-maroon" data-id="element-167">
                    {member.role}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>
    </div>;
}